module.exports = __webpack_public_path__ + "img/vertical_5_1_2.98312c3a.png";